import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=4a70ae3e&scoped=true&"
var script = {}
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=4a70ae3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a70ae3e",
  null
  
)

export default component.exports